export default (initialState, actionHandlers) =>
  (state = initialState, action) => {
    const { type } = action;
    if (actionHandlers.has(type)) {
      return actionHandlers.get(type)(state, action);
    }
    return state;
  };
